export const DOWNLOAD_CENTRE_POPOVER_ID = 'download-centre'
export const DOWNLOAD_COMPLETE_MESSAGE_VISIBLE_MS = 5000
export const DOWNLOAD_RETRY_MIN_VISIBLE_MS = 1000
